/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Mentoringtopic1Inputs */

const en__field_mentoringtopic1 = /** @type {(inputs: _Field_Mentoringtopic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which topics are especially important to you?`)
};

const de__field_mentoringtopic1 = /** @type {(inputs: _Field_Mentoringtopic1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Themen sind dir im Mentoring besonders wichtig? Bitte kreuze an. (max. 3 auswählen)`)
};

/**
* | output |
* | --- |
* | "Which topics are especially important to you?" |
*
* @param {_Field_Mentoringtopic1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_mentoringtopic1 = /** @type {((inputs?: _Field_Mentoringtopic1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Mentoringtopic1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_mentoringtopic1(inputs)
	return de__field_mentoringtopic1(inputs)
});
export { _field_mentoringtopic1 as "_field_mentoringTopic" }